import { createSlice } from '@reduxjs/toolkit';
import { setAdminConfig, setEmailConfig } from '../member/api-calls/member';
import { setAdminEmailConfig } from '../admin/api-calls/members';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    userData: null,
    bearerToken: null,
    isLoggedIn: false,
    userRoleAndPermissions: null,
    adminConfigData: {},
    hasSecurityQuestions: false,
    emailConfigData: {},
    emailAdminConfigData: {},
    memberAffiliatedAccountList: [],
  },
  reducers: {
    setIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
    setUserData: (state, { payload }) => {
      state.userData = {
        ...(state.userData || {}),
        ...payload,
      };
    },
    setBearerToken: (state, action) => {
      if (action.payload) {
        state.bearerToken = action.payload;
      }
    },
    setUserRoleAndPermissions: (state, action) => {
      state.userRoleAndPermissions = action.payload;
    },
    logout: (state, action) => {
      //state.bearerTokenOnLogout = action.payload.preserveBearerToken ? state.bearerToken : null;
      state.logoutApiConsumed = action.payload?.preserveBearerToken
        ? false
        : true;
      state.userData = null;
      state.isLoggedIn = false;
      state.bearerToken = action.payload?.preserveBearerToken
        ? state.bearerToken
        : null;
      state.userRoleAndPermissions = null;
      state.adminConfigData = {};
      state.emailConfigData = {};
      state.shouldNavigateToLogin = true;
    },
    resetUnauthorizedNavigationStatus: (state) => {
      state.shouldNavigateToLogin = false;
      state.redirectedDueToError = true;
    },
    setAdminConfigPasswordRules: (state, action) => {
      state.adminConfigData.passwordRules = action.payload;
    },
    setAdminConfigOTPSettings: (state, { payload }) => {
      state.adminConfigData.otpSettings = payload;
    },
    setAdminConfigPortalSettings: (state, { payload }) => {
      state.adminConfigData.portalSettings = payload;
    },
    setAdminConfigAttributeNameConfiguration: (state, { payload }) => {
      state.adminConfigData.attributeNameConfiguration = payload;
    },
    setHasSecurityQuestions: (state, action) => {
      state.hasSecurityQuestions = action.payload;
    },
    setMemberAffiliatedAccountList: (state, action) => {
      state.memberAffiliatedAccountList = action.payload;
    },
    resetMemberAffiliatedAccountList: (state) => {
      state.memberAffiliatedAccountList = [];
    },
  },
  extraReducers: {
    [setAdminConfig.fulfilled]: (state, action) => {
      state.adminConfigData = action.payload;
    },
    [setEmailConfig.fulfilled]: (state, action) => {
      state.emailConfigData = action.payload;
    },
    [setEmailConfig.rejected]: (state, action) => {
      state.emailConfigData = {};
    },
    [setAdminEmailConfig.fulfilled]: (state, action) => {
      state.emailAdminConfigData = action.payload;
    },
    [setAdminEmailConfig.rejected]: (state, action) => {
      state.emailAdminConfigData = {};
    },
  },
});

//Action creators are generated for each case reducer function
export const {
  setUserData,
  setIsLoggedIn,
  setBearerToken,
  setUserRoleAndPermissions,
  logout,
  resetUnauthorizedNavigationStatus,
  setAdminConfigPasswordRules,
  setAdminConfigOTPSettings,
  setAdminConfigPortalSettings,
  setAdminConfigAttributeNameConfiguration,
  setHasSecurityQuestions,
  setMemberAffiliatedAccountList,
  resetMemberAffiliatedAccountList,
} = userSlice.actions;

export default userSlice.reducer;
